import script from "./GroupSurveys.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupSurveys.vue?vue&type=script&setup=true&lang=js"

import "./GroupSurveys.vue?vue&type=style&index=0&id=01140c16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01140c16"]])

export default __exports__